import React from 'react';
import List from 'components/atoms/text/list';
import { CommonOrganismProps } from '../../types';
import Section from '..';

interface Props extends CommonOrganismProps {
  items: Object;
}

export default function SectionWithList({ title, items, styles, ...restProps }: Props) {
  return (
    <Section title={title} styles={styles} {...restProps}>
      <List items={items} />
    </Section>
  );
}
